import React from 'react';

interface Props {
  width?: string;
  height?: string;
}

const FreeSvg: React.FC<Props> = ({ width, height }) => {
  return (
    <svg
      width={width ?? '23'}
      height={height ?? '9'}
      viewBox='0 0 23 9'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M0 0.488281H4.94649V2.08828H1.83077V3.96257H4.44615V5.574H1.83077V8.48828H0V0.488281Z'
        fill='white'
      />
      <path
        d='M11.2543 3.02542C11.2543 3.26161 11.224 3.49781 11.1633 3.734C11.1103 3.96257 11.0193 4.1759 10.8904 4.374C10.7616 4.56447 10.5986 4.7359 10.4015 4.88828C10.2044 5.04066 9.96179 5.16638 9.67372 5.26542V5.31114L11.6068 8.48828H9.2871L8.059 5.574H7.42221V8.48828H5.59145V0.488281H8.30917C8.81709 0.488281 9.25677 0.560662 9.62823 0.705424C9.99969 0.850186 10.3067 1.04066 10.5493 1.27685C10.7919 1.51304 10.97 1.78352 11.0838 2.08828C11.1975 2.39304 11.2543 2.70542 11.2543 3.02542ZM9.33258 3.05971C9.33258 2.93781 9.31363 2.81971 9.27573 2.70542C9.23782 2.58352 9.17338 2.48066 9.08241 2.39685C8.99144 2.30542 8.87015 2.23304 8.71854 2.17971C8.5745 2.11876 8.39635 2.08828 8.18409 2.08828H7.42221V4.04257H8.18409C8.39635 4.04257 8.5745 4.0159 8.71854 3.96257C8.87015 3.90923 8.98765 3.83685 9.07104 3.74542C9.16201 3.654 9.22645 3.54733 9.26435 3.42542C9.30984 3.30352 9.33258 3.18161 9.33258 3.05971Z'
        fill='white'
      />
      <path
        d='M17.1642 8.48828H12.1268V0.488281H17.0505V2.08828H13.9576V3.59685H16.4592V5.12828H13.9576V6.88828H17.1642V8.48828Z'
        fill='white'
      />
      <path
        d='M23 8.48828H17.9625V0.488281H22.8863V2.08828H19.7933V3.59685H22.295V5.12828H19.7933V6.88828H23V8.48828Z'
        fill='white'
      />
    </svg>
  );
};

export default FreeSvg;
